import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import './App.css';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { createBrowserHistory } from 'history';
import App from './App';
import configureStore from './redux-modules/configureStore';
import VersionChecker from './VersionChecker';

export const { store, persistor } = configureStore(createBrowserHistory());

const clearStaleAuthState = async (): Promise<void> => {
    const refreshToken = sessionStorage.getItem('refreshToken');
    const persistedState = sessionStorage.getItem('persist:firstMatch')
        || sessionStorage.getItem('persist:First-match');

    if (persistedState && !refreshToken) {
        console.warn('[Auth] Stale Redux state detected — clearing');
        await persistor.purge();
        sessionStorage.removeItem('refreshToken');
        sessionStorage.removeItem('user_role');
        localStorage.removeItem('sessionOut');
        sessionStorage.removeItem('persist:firstMatch');
        sessionStorage.removeItem('persist:First-match');
        console.info('[Auth] Stale state cleared — fresh login required');
    }
};

const Root = () => {

    useEffect(() => {
        const initAuth = async () => {
            await clearStaleAuthState();
        };
        initAuth();
    }, []);



    return (
        <>
            <App />
        </>
    );
};

ReactDOM.render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Router>
                    <VersionChecker />
                    <Root />
                </Router>
            </MuiPickersUtilsProvider>
        </PersistGate>
    </Provider>,
    document.getElementById('root')
);